import { render, staticRenderFns } from "./ManageCollaborators.vue?vue&type=template&id=a9b50ec8"
import script from "./ManageCollaborators.vue?vue&type=script&lang=ts"
export * from "./ManageCollaborators.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports